import React from 'react'
import styled from 'styled-components'
import { Box, getPaletteColor } from 'pcln-design-system'
import { HighlightedFlex } from '@pcln/brand'
import { Booking } from './types'
import { buildContent, X_SELL_PRODUCTS } from './utils'
import Inventory from './Inventory'
import NoInventoryFallback from './NoInventoryFallback'
import BookingInfo from './BookingInfo'
import useCrossSellInventory from './useCrossSellInventory'
import useCrossSellAnalytics from './useCrossSellAnalytics'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

const Wrapper = styled(Box)`
  border-top: 4px solid ${getPaletteColor('primary.base')};
`

export default function CrossSell({ booking }: { booking: Booking }) {
  const {
    product,
    date,
    headline,
    offerToken,
    subHeadline,
    xSellMessaging,
    xSellTarget,
    xSellUrl
  } = buildContent(booking)

  const xSellProduct = X_SELL_PRODUCTS[xSellTarget]

  const { listings, offerId, loading } = useCrossSellInventory(booking)
  useCrossSellAnalytics(listings)

  return (
    <LayoutComponentWrapper>
      <Box className="cross-sell-container">
        <HighlightedFlex
          shadowOffsetX={24}
          shadowOffsetY={24}
          maxWidth={1216}
          flexDirection={['column', null, 'row']}
          alignItems="center"
        >
          <Wrapper
            width={[1, null, 1 / 3, null, 3 / 11]}
            color="background.lightest"
            boxShadowSize="md"
            borderRadius="xl"
          >
            <BookingInfo
              product={product}
              date={date}
              headline={headline}
              subHeadline={subHeadline}
            />
          </Wrapper>
          {offerId &&
            (listings.length > 1 ? (
              <Inventory
                listings={listings}
                offerId={offerId}
                xSellMessaging={xSellMessaging}
                xSellProduct={xSellProduct}
                rudderParentProductCode={product}
                rudderChildProductCode={xSellProduct}
                xSellUrl={xSellUrl}
                offerToken={offerToken}
              />
            ) : (
              <NoInventoryFallback
                xSellMessaging={xSellMessaging}
                xSellTarget={xSellTarget}
                xSellUrl={xSellUrl}
                rudderParentProductCode={product}
                rudderChildProductCode={xSellProduct}
                offerId={offerId}
                dataIsLoading={loading}
              />
            ))}
        </HighlightedFlex>
      </Box>
    </LayoutComponentWrapper>
  )
}
